import {
  EDIT_COURSE_SET_COURSE_ID,
  EDIT_COURSE_SET_COURSE_DATA,
  EDIT_COURSE_SET_IS_CREATE_NEW_COURSE,
  EDIT_COURSE_SET_IS_TRANSCRIPTION_ENABLED,
  EDIT_COURSE_SET_IS_UNIT_REORDER_ENABLED,
  EDIT_COURSE_SET_IS_MODULE_REORDER_ENABLED,
  EDIT_COURSE_SET_MODULE_TYPE_OPTIONS_INDEX,
  EDIT_COURSE_SET_CURRENTLY_EDITED,
  EDIT_COURSE_SET_WAS_ORDER_CHANGED,
  SET_MANAGE_GROUPS_GROUPS_DATA,
  SET_MANAGE_GROUP_SESSIONS_DATA,
  SET_MANAGE_GROUPS_USERS_DATA,
  SET_MANAGE_GROUPS_MENTORS_DATA,
  SET_MANAGE_GROUPS_SET_SELECTED_GROUP_ID,
  EDIT_COURSE_SET_TRANSCRIBE_SERVICE,
  SET_CONTENT_FEEDBACK_STORE
} from '../../constants';

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  editCourseData: {
    isUnitReorderEnabled: false,
    isModuleReorderEnabled: true,
    isSomethingInEditing: false,
    wasOrderChanged: false,
    moduleTypeOptionsIndex: 0,
    currentlyEdited: {units: [], modules:[]}
  }
});

function editCourseReducer(state = INITIAL_STATE, action =
  {
    type: '',
    courseId: null,
    courseData: null,
    isCreateNewCourse: null,
    isTranscriptionEnabled: null,
    isUnitReorderEnabled: null,
    isModuleReorderEnabled: null,
    moduleTypeOptionsIndex: 0,
    currentlyEdited: null,
    wasOrderChanged: false,
    groupsData: null,
    sessionsData: null,
    licensedUsersData: null,
    mentorsData: null,
    selectedGroupId: null,
    transcribeService: null
  }) {


  switch (action.type) {

    case EDIT_COURSE_SET_COURSE_ID:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          courseId: action.courseId,
        })),
      }));

    case EDIT_COURSE_SET_COURSE_DATA:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          courseData: action.courseData,
        })),
      }));

    case EDIT_COURSE_SET_IS_CREATE_NEW_COURSE:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          isCreateNewCourse: action.isCreateNewCourse,
        })),
      }));

    case EDIT_COURSE_SET_IS_TRANSCRIPTION_ENABLED:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          isTranscriptionEnabled: action.isTranscriptionEnabled,
        })),
      }));


      case EDIT_COURSE_SET_IS_UNIT_REORDER_ENABLED:
      {
        let isSomethingInEditing = state.get("editCourseData").get("isSomethingInEditing");
        let newIsModuleReorderEnabled = true;
        if (action.isUnitReorderEnabled || isSomethingInEditing) {
          newIsModuleReorderEnabled = false;
        }

        return state.merge(fromJS({
          editCourseData: state.get('editCourseData').merge(fromJS({
            isUnitReorderEnabled: action.isUnitReorderEnabled,
            isModuleReorderEnabled: newIsModuleReorderEnabled,
          })),
        }));
      }


    case EDIT_COURSE_SET_IS_MODULE_REORDER_ENABLED:
      {
        let isSomethingInEditing = state.get("editCourseData").get("isSomethingInEditing");
        let isUnitReorderEnabled = state.get("editCourseData").get("isUnitReorderEnabled");
        let newIsModuleReorderEnabled = action.isModuleReorderEnabled;
        if (isUnitReorderEnabled || isSomethingInEditing) {
          newIsModuleReorderEnabled = false;
        }
        
        return state.merge(fromJS({
          editCourseData: state.get('editCourseData').merge(fromJS({
            isModuleReorderEnabled: newIsModuleReorderEnabled,
          })),
        }));
      }

      
    case EDIT_COURSE_SET_MODULE_TYPE_OPTIONS_INDEX:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          moduleTypeOptionsIndex: action.moduleTypeOptionsIndex,
        })),
      }));


    case EDIT_COURSE_SET_CURRENTLY_EDITED:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          currentlyEdited: action.currentlyEdited,
        })),
      }));

    case EDIT_COURSE_SET_TRANSCRIBE_SERVICE:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          transcribeService: action.transcribeService,
        })),
      }));

    case EDIT_COURSE_SET_WAS_ORDER_CHANGED:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          wasOrderChanged: action.wasOrderChanged,
        })),
      }));

      case SET_MANAGE_GROUPS_GROUPS_DATA:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          groupsData: action.groupsData,
        })),
      }));

      case SET_MANAGE_GROUP_SESSIONS_DATA:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          sessionsData: action.sessionsData,
        })),
      }));

      case SET_MANAGE_GROUPS_USERS_DATA:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          licensedUsersData: action.licensedUsersData,
        })),
      }));

      case SET_MANAGE_GROUPS_MENTORS_DATA:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          mentorsData: action.mentorsData,
        })),
      }));

      case SET_MANAGE_GROUPS_SET_SELECTED_GROUP_ID:
      return state.merge(fromJS({
        editCourseData: state.get('editCourseData').merge(fromJS({
          selectedGroupId: action.selectedGroupId,
        })),
      }));

    default:
      return state;
  }
}

export default editCourseReducer;
